import React, { useMemo, useContext } from "react";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";

import { InitiativesLayout } from "../../../organisms/Layouts";
import { H3, P } from "../../../atoms/Texts";

import notSearchedImg from "../../../../assets/images/Curly Arrow.svg";

import { SendInviteCard } from "../../../atoms/Cards";
import { demoContext } from "../../../../shared/store/contexts";

const PendingInitiativeRequest = () => {
  const { invites } = useContext(demoContext);

  return (
    <InitiativesLayout>
      <div className="pb-8 ">
        {invites?.length > 0 ? (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {invites?.map((item) => (
              <SendInviteCard key={item.id} item={item} type="sent" />
            ))}
          </div>
        ) : (
          <>
            <div className="flex flex-col items-center flex-grow justify-center">
              <img src={notSearchedImg} alt="" className="" />
              <H3
                color="#22202D"
                className="mt-6 text-center"
                data-testid="eligibility-text"
              >
                You do not have pending invites yet
              </H3>
              <P fontSize="16px" color="#7D7B96" className="mt-3 mb-0 text-center">
                Search for the initiative to join or create an initiative
              </P>
            </div>
          </>
        )}
      </div>
    </InitiativesLayout>
  );
};

export default PendingInitiativeRequest;
